import React from 'react'
import { components as AuthComponents } from '../modules/auth';

export const AuthPage = () => {
    return (
        <AuthComponents.Login />
    );
}
